import { XmlElement, XmlFragment } from 'yjs';

type YXmlList = XmlFragment | XmlElement;

function scoreElement(el: XmlElement): number {
  let score = 0;
  if (el.getAttribute('src')) score += 100;
  if (el.getAttribute('streamId')) score += 50;
  if (el.getAttribute('processing')) score += 25;
  if (el.getAttribute('thumbnail')) score += 10;
  if (el.getAttribute('name')) score += 5;
  score += el.length;
  return score;
}

/**
 * Remove sibling/descendant XmlElements that share the same block `id` attribute.
 * Keeps the higher-scoring copy (prefers in-flight / completed media attrs).
 *
 * @returns number of nodes removed
 */
export function dedupeYXmlFragmentByBlockId(list: YXmlList): number {
  let removed = 0;
  const children = list.toArray();
  const seen = new Map<string, { el: XmlElement; index: number }>();
  const deleteIndices: number[] = [];

  children.forEach((child, index) => {
    if (!(child instanceof XmlElement)) {
      return;
    }

    removed += dedupeYXmlFragmentByBlockId(child);

    const id = child.getAttribute('id');
    if (!id) {
      return;
    }

    const existing = seen.get(id);
    if (!existing) {
      seen.set(id, { el: child, index });
      return;
    }

    if (scoreElement(child) > scoreElement(existing.el)) {
      deleteIndices.push(existing.index);
      seen.set(id, { el: child, index });
    } else {
      deleteIndices.push(index);
    }
  });

  deleteIndices
    .sort((a, b) => b - a)
    .forEach((index) => {
      list.delete(index, 1);
      removed += 1;
    });

  return removed;
}
